import { faTrophy } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const Prizing = (props) => {
    return (
        <div className='tg23-prizing_cointainer'>
            <p className="tg23-section-heading" data-value="PRIZES" onMouseOver={props.mouseHover}>PRIZES</p>
            <div className="tg23-prizing_wrapper">
                <div className="tg23-awards">
                    <div className="silver-award tg23-awards-wrapper bottom-0">
                        <FontAwesomeIcon icon={faTrophy} />
                        <p>₹2,000</p>
                    </div>
                </div>
                <div className="tg23-awards">
                    <div className="golden-award tg23-awards-wrapper">
                        <FontAwesomeIcon icon={faTrophy} />
                        <p>₹5,000</p>
                    </div>
                </div>
                <div className="tg23-awards">
                    <div className="bronze-award tg23-awards-wrapper bottom-0">
                        <FontAwesomeIcon icon={faTrophy} />
                        <p>₹1,000</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Prizing